import { createSlice } from '@reduxjs/toolkit';

import { getReserves, getExchangeDirections } from './app.actions';

const initialState = {
  reserves: [],
  isLoadingReserves: false,

  exchangeDirections: [],
  exchangeDirectionsMeta: [],
  isLoadingExchangeDirections: false,

  contactUsErrors: {},
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setExchangeDirectionsMeta: (state, action) => {
      state.exchangeDirectionsMeta = action.payload;
    },
    setContactUsErrors: (state, action) => {
      state.contactUsErrors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReserves.pending, (state) => {
      state.isLoadingReserves = true;
    });
    builder.addCase(getReserves.fulfilled, (state, action) => {
      state.reserves = action.payload;
      state.isLoadingReserves = false;
    });
    builder.addCase(getReserves.rejected, (state) => {
      state.isLoadingReserves = false;
    });

    builder.addCase(getExchangeDirections.pending, (state) => {
      state.isLoadingExchangeDirections = true;
    });
    builder.addCase(getExchangeDirections.fulfilled, (state, action) => {
      state.exchangeDirections = action.payload;
      state.isLoadingExchangeDirections = false;
    });
    builder.addCase(getExchangeDirections.rejected, (state) => {
      state.isLoadingExchangeDirections = false;
    });
  },
});

export const { setExchangeDirectionsMeta, setContactUsErrors } = appSlice.actions;

export default appSlice.reducer;
